import { apiGet } from "@/lib/http/client";
import type { DashboardStats } from "@/types/api";

export async function fetchDashboardStats() {
  return apiGet<DashboardStats>("/dashboard/stats");
}
